import React, { useEffect, useState } from "react";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  XAxis,
  Tooltip,
  Cell,
} from "recharts";
import { getStudentAttenList } from "../../../../services/dashboard";
import styles from "./student-presence.module.css";
import { Spin } from "antd";

const RoundedBar = ({ x, y, height, fill }) => {
  const radius = 4;
  return (
    <rect
      x={x}
      y={y}
      width={16}
      height={height}
      fill={fill}
      rx={radius}
      ry={radius}
      style={{ transition: "fill 0.3s ease" }}
    />
  );
};

const ActiveRoundedBar = (props) => <RoundedBar {...props} fill="#5FC7D6" />;

const StudentPresence = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [presentStudent, setPresentStudent] = useState("");
  const [totalStudents, setTotalStudents] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchAttendanceData = async () => {
    setLoading(true);
    try {
      const response = await getStudentAttenList();

      const rawData = response?.data;
      setAttendanceData(rawData?.data);

      const studentData = rawData?.header;
      setTotalStudents(studentData?.total_students);
      setPresentStudent(studentData?.present_students);

    } catch (error) {
      console.error("Error fetching overall presence data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAttendanceData([]);
    fetchAttendanceData();
  }, []);

  return (
    <CustomCard style={{ height: 270 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          columnGap: 7,
          marginBottom: 16,
        }}
      >
        <span className={styles.card_heading}>
          Total Students Present Today ({presentStudent}/{totalStudents})
        </span>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>

      <Spin spinning={loading}>
        <ResponsiveContainer width="100%" height={190}>
          <BarChart data={attendanceData}>
            <XAxis dataKey="label" />
            <Tooltip
              cursor={{ fill: "transparent" }}
              content={({ active, payload }) =>
                active && payload?.length ? (
                  <div
                    style={{
                      background: "#5FC7D6",
                      color: "#fff",
                      padding: "4px 8px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: "bold",
                    }}
                  >
                    {payload[0].value}%
                  </div>
                ) : null
              }
            />
            <Bar
              dataKey="value"
              shape={<RoundedBar />}
              activeBar={<ActiveRoundedBar />}
            >
              {attendanceData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill="#E1E6EA" />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    </CustomCard>
  );
};

export default StudentPresence;
